var debounce = window.debounce;

/**
 * @class
 * @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => { this.onSubmitHandler(event); }, 200);
      this.inputs.forEach((item) => { item.addEventListener('change', this.debouncedOnSubmit.bind(this)); });
    }
    onSubmitHandler(event) { if (this.form) this.form.submit(); }
  }
  customElements.define('localization-form', LocalizationForm);
}

/* WS — country selector currency-label repair
   Label-only fix: keeps Shopify's country_code values and pricing untouched. */
(function () {
  var GROUPS = "AED:AE|AUD:AU,CC,CX,HM,KI,NF,NR,TV|CAD:CA|CHF:CH,LI|DKK:DK,FO,GL|EUR:AD,AT,AX,BE,BL,CY,DE,EE,ES,FI,FR,GF,GP,GR,HR,IE,IT,LT,LU,LV,MC,ME,MF,MQ,MT,NL,PM,PT,RE,SI,SK,SM,TF,VA,YT|GBP:GB,GG,GS,IM,JE|INR:IN|PKR:PK|SAR:SA|USD:AS,BQ,EC,FM,GU,HT,IO,MH,MP,PA,PR,PW,SV,TC,TL,UM,US,VG,VI|ZAR:ZA";
  var SYMBOLS = {AED:"د.إ",AUD:"$",CAD:"$",CHF:"CHF",DKK:"kr",EUR:"€",GBP:"£",INR:"₹",PKR:"Rs",SAR:"ر.س",USD:"$",ZAR:"R"};
  var byCountry = {};
  GROUPS.split("|").forEach(function(group){var p=group.split(":");(p[1]||"").split(",").forEach(function(c){if(c)byCountry[c]=p[0];});});
  function repairCurrencyLabels(){
    document.querySelectorAll('select[name="country_code"]').forEach(function(select){
      Array.prototype.forEach.call(select.options,function(option){
        var currency=byCountry[(option.value||"").toUpperCase()];
        if(!currency)return;
        var name=option.textContent.replace(/\s*\([^)]*\)\s*$/,"").trim();
        var symbol=SYMBOLS[currency]||"";
        option.textContent=name+" ("+currency+(symbol?" "+symbol:"")+")";
      });
    });
  }
  function syncSelectedCountryToActiveCurrency(){
    var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if(!active)return;
    var preferred = {USD:"US",GBP:"GB",PKR:"PK",AED:"AE",CAD:"CA",AUD:"AU",EUR:"DE"};
    var preferredCountry = preferred[active];
    document.querySelectorAll('select[name="country_code"]').forEach(function(select){
      var match = preferredCountry && select.querySelector('option[value="'+preferredCountry+'"]');
      if(!match){
        Array.prototype.some.call(select.options,function(option){
          return byCountry[(option.value||"").toUpperCase()] === active && (match=option);
        });
      }
      if(match) select.value = match.value;
    });
  }
  function repairAndSync(){
    repairCurrencyLabels();
    syncSelectedCountryToActiveCurrency();
  }
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",repairAndSync,{once:true});}else{repairAndSync();}
  window.addEventListener("load",repairAndSync,{once:true});
})();